import { render, staticRenderFns } from "./versionsTab.vue?vue&type=template&id=93b1187a"
import script from "./versionsTab.vue?vue&type=script&lang=js"
export * from "./versionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports